import React from "react";
import styled from "styled-components";
import DescIcon from "../icon/Desc";
import Row from './Row'

const Guide = ({ list, position, icon, children, tourId}) => {
    return (
        <IconWrap 
            id={tourId}
            hasChildren={children !== undefined}>
            <IconHover position={position}>
                {list.map(i => (
                    Array.isArray(i) ? <Row item='center'>
                        {i.map(p => {
                            return (
                                typeof p === 'object' 
                                ? <Row width='auto' direction='column' item='center' margin='.5rem' padding='0 5px'>
                                    {p.numerator}
                                    <hr/>
                                    {p.denominator}
                                </Row>
                                : p
                            )
                        })}
                    </Row>
                    : <div>{i}</div>
                ))}
            </IconHover>
            {children ? children : <DescIcon size='12px'/>}
        </IconWrap>
    );
};
export default Guide;
const IconHover = styled.div`
    position: absolute;
    left: 50%;
    top: 100%;
    transform: ${({ position}) => position ? `translateX(${position})` : 'translateX(-50%)'};
    display: none;
    flex-direction: column;
    font-size: 12px;
    width: auto;
    height: auto;
    background-color: #666;
    color: #fff;
    padding: 8px;
    border-radius: 5px;
    white-space: nowrap;
    z-index: 10000;
    hr {
        width: calc(100% + 10px);
        margin: .1rem 0;
    }
`;
const IconWrap = styled.div`
    position: relative;
    /* display: inline-block; */
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-left: ${({ hasChildren }) => hasChildren ? '' : '10px'};
    &:hover {
        ${IconHover} {
            display: flex;
            z-index: 10000;
        }
    }
    @media(max-width: 900px) {
        svg {
            font-size: 16px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/dev/Guide.js